/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-23 13:29:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/Components/StatusTag/index.tsx
 */
import { Status } from '@/src/types/common/miniProgram';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const StatusTag = ({ status }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const tagText = {
    [Status.Processing]: 'salesChannelMiniProgramSettings.index.processing',
    [Status.Rejected]: 'salesChannelMiniProgramSettings.index.rejected',
    [Status.Passed]: 'salesChannelMiniProgramSettings.index.passed',
    [Status.Live]: 'salesChannelMiniProgramSettings.index.liveVersion',
    [Status.Offline]: 'salesChannelMiniProgramSettings.index.previousVersion',
  };
  const tagColor = {
    [Status.Processing]: { color: '#1B93C5', backgroundColor: '#F4FCFF' },
    [Status.Rejected]: { color: '#FFA39E', backgroundColor: '#FFF1F0' },
    [Status.Passed]: { color: '#B7EB8F', backgroundColor: '#F6FFED' },
    [Status.Live]: { color: '#B7EB8F', backgroundColor: '#F6FFED' },
    [Status.Offline]: { color: '#B9BCBF', backgroundColor: '#F4F5F7' },
  };
  return status ? (
    <div
      className={css.statusTag}
      style={{
        ...tagColor[status],
        border: `1px solid ${tagColor[status].color}`,
      }}>
      {getI18n(tagText[status])}
    </div>
  ) : null;
};

export default StatusTag;
